// Shared across every proposal: the offers and negotiation section.
// Edit here once; every client's page picks it up.

export const offers = {
  intro: "The highest offer isn't always the best one.",
  text: "I weigh every offer on price, terms and risk, so you choose the one most likely to close for the most money.",
  rows: [
    { label: "Highest price", offer1: true, offer2: false },
    { label: "Best terms (less risk)", offer1: false, offer2: true },
    { label: "Solid financing", offer1: false, offer2: true },
    { label: "Most likely to close", offer1: false, offer2: true },
  ],
  strongTerms: [
    { term: "Down payment amount", text: "A larger down payment means a stronger, more reliable buyer." },
    { term: "Earnest money amount", text: "More at stake makes a buyer less likely to walk away." },
    { term: "Close quickly", text: "A shorter timeline leaves less room for surprises." },
    { term: "Non-refundable earnest money", text: "Held by the seller, so a late exit costs the buyer." },
    { term: "Inspection contingency waived", text: "Removes a common way for a buyer to back out." },
    { term: "Finance contingency waived", text: "Removes the risk of the buyer's loan falling through." },
    {
      term: "Appraisal gap coverage",
      text: "The buyer covers the difference if the appraisal comes in low.",
    },
  ],
};
